// 问董秘
// 概念、互动、关键词 top 10
import request from '@/utils/request'
import { stockpoolurl } from './config'
// import { logicalExpression } from '@babel/types';
type dataType = any
export default {
  getStockPoolList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: stockpoolurl + '/pool/api/1/strategy/stock/pool/list',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  }
}
